import {LandingEnum} from "./LandingEnum";

let relations

switch (process.env.REACT_APP_MODULE) {
  case 'charisma':
    relations = {
      [LandingEnum.charisma]: ['en'],
    }
    break

  default:
    relations = {
      [LandingEnum.adhd]: ['en'],
      [LandingEnum.interview]: ['en', 'es', 'de', 'fr'],
      [LandingEnum.dating]: ['en'],
      [LandingEnum.voiceage]: ['en'],
      [LandingEnum.smalltalk]: ['en', 'es'],
    }
    break
}

export const LandingRelationsEnum = Object.freeze(relations)